var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1300 650",
    style: {
      enableBackground: "new 0 0 1300 650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00BE00;}\n\t.st1{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1121.19,625 992.96,625 992.96,134.68 841.35,134.68 841.35,25 1273.61,25 1273.61,134.68  1121.19,134.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "558.47,257.26 752.82,257.26 753.63,366.93 558.47,367.74 558.47,625 430.24,625 430.24,25 818.95,25  818.95,134.68 558.47,134.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.39,25 154.62,25 154.62,515.32 407.84,515.32 407.84,625 26.39,625  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1267.57,603.44L1261.4,625h-5.14l-6.08-21.51V625h-6.04v-31.63h9.06l5.61,20.32l5.66-20.32h9.14V625h-6.04 V603.44z M1232.71,625h-6.76v-25.85h-7.99v-5.78h22.79v5.78h-8.04V625z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.365a9f816a8369e72cb4be1991269d53.svg";
export { ForwardRef as ReactComponent };